<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'logisticsType',
      key:'id',
       url: {
          get:'/admin/logisticsType',
        },
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        {
          label: '物流名称',
          name: 'logisticsType',
          value: '',
          type: 'input',
          width:'300px',
          rules: [{ required: true, trigger: 'blur', }],
        },
        { label: '物流详情', name: 'logisticsDetail', value: '', type: 'input',width:'300px'},
        // { label: '物流创建人', name: 'createBy', value: '', type: 'input',width:'300px'},
        //{ label: "状态", name: "status", value: 1, type: "switch", trueValue: 1, falseValue: 0 },
      ],
      forms: {
        id:"",
        createBy:$utils.data.get("auth", "customer")
      },
    }
  },
  created() {
    this.loadLevelData()
  },
  methods: {
    onCouponAlis(val) {
      let ass = val.join(",");
      this.value = ass;
    },
    // handleSubmit() {
    //   if (!this.action) {
    //     return true
    //   }
    //   this.forms.id=this.$route.query.kv
    //   let q = this.forms;
    //   this.forms.label = q.id;
    //   const action=this.$route.query.action
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       this.sloading = true
    //       $utils.api
    //         .load(`/admin/logisticsType/update`, q, 'POST')
    //         .then((res) => {
    //           this.sloading = false
    //           if (res.status) {
    //             $utils.toast.success('保存成功')
    //             $utils.url.go(-1)
    //           }
    //         })
    //         .catch((e) => {
    //           this.sloading = false
    //           $utils.toast.error('保存异常' + e.message)
    //         })
    //     }
    //   })
    // },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {}
      $utils.api.load('/admin/logisticsType/list', q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows
          let dropList = []
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index]
            let xx = {}
            xx.value = element.id
            xx.name = element.facilityName
            xx.children = element.children || []
            dropList.push(xx)
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index]
            if (element && element.name == 'logisticsTypeId') {
              // this.items[index]['dropList'] = dropList
              this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
            }
          }
        }
      })
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      this.forms.id=this.$route.query.kv
      let q = this.forms;
      this.forms.label = q.id;
      const action=this.$route.query.action
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true
          if(action=='edit'){
            $utils.api
                .load(`/admin/logisticsType/update`, q,  'POST')
                .then((res) => {
                  this.sloading = false
                  if (res.status) {
                    $utils.toast.success('保存成功')
                    $utils.url.go(-1)
                  }
                })
                .catch((e) => {
                  this.sloading = false
                  $utils.toast.error('保存异常' + e.message)
                })
          }else{ $utils.api
              .load(`/admin/logisticsType/add`, q,  'POST')
              .then((res) => {
                this.sloading = false
                if (res.status) {
                  $utils.toast.success('保存成功')
                  $utils.url.go(-1)
                }
              })
              .catch((e) => {
                this.sloading = false
                $utils.toast.error('保存异常' + e.message)
              })}
        }
      });
    },
  },
}
</script>
